// extracted by mini-css-extract-plugin
module.exports = {"root":"beverage-disposal-page_root__GWAW_"};